import {
  format,
  formatDistanceToNow,
  isAfter,
  isSameDay,
  parse,
  subHours,
} from 'date-fns'

const DATE_ONLY_FORMAT = 'yyyy-MM-dd'
const TIME_FORMAT = 'hh:mm a'
const DATE_FORMAT = 'MMM dd yyyy'

const toDateOrNull = (value, valueFormat) => {
  if (!value) return null
  const parsedDate = valueFormat
    ? parse(value, valueFormat, new Date())
    : new Date(value)

  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate
}

const toUtcDateOrNull = (value) => {
  if (!value) return null

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value
  }

  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)) {
    const utcDate = new Date(value.replace(' ', 'T') + 'Z')
    return Number.isNaN(utcDate.getTime()) ? null : utcDate
  }

  return toDateOrNull(value)
}

const formatFromNow = (date) => formatDistanceToNow(date, { addSuffix: true })

export function formatMessageDate (time) {
  const today = new Date()
  const date = toDateOrNull(time, DATE_ONLY_FORMAT)
  if (!date) return ''
  if (isSameDay(date, today)) {
    return 'Today'
  }
  return formatGeneralDate(date)
}

export function formatPostDate (time) {
  const today = new Date()
  const date = toUtcDateOrNull(time)
  if (!date) return ''
  if (isSameDay(date, today) || isAfter(date, subHours(new Date(), 24))) {
    return formatFromNow(date)
  }
  return formatGeneralDate(date)
}

export function formatPostDateWithoutYear (time) {
  const today = new Date()
  const date = toUtcDateOrNull(time)
  if (!date) return ''
  if (isSameDay(date, today) || isAfter(date, subHours(new Date(), 24))) {
    return formatFromNow(date)
  }
  const currentYear = today.getFullYear()
  const postYear = date.getFullYear()
  if (currentYear === postYear) {
    return format(date, 'MMM dd')
  }
  return formatGeneralDate(date)
}

export function formatNotificationDate(time) {
  const today = new Date()
  const date = toDateOrNull(time)
  if (!date) return ''

  let dateLabel = formatGeneralDate(date)
  if (isSameDay(date, today)) {
    dateLabel = 'Today'
  }
  
  return `${format(date, TIME_FORMAT)}, ${dateLabel}`
}

export function formatCommentDate(time) {
  const today = new Date()
  const date = toDateOrNull(time)
  if (!date) return ''

  let dateLabel = formatGeneralDate(date)
  if (isSameDay(date, today)) {
    dateLabel = 'Today'
  }

  return `${format(date, TIME_FORMAT)}, ${dateLabel}`
}

export function formatTransactiontDate(time) {
  const date = toDateOrNull(time)
  if (!date) return ''
  return `${format(date, TIME_FORMAT)}, ${format(date, DATE_FORMAT)}`
}

export function formatGeneralDate (date) {
  const parsedDate = toDateOrNull(date)
  if (!parsedDate) return ''
  return format(parsedDate, DATE_FORMAT)
}

export const formatLastSeen = (last_seen) => {
  const date = toDateOrNull(last_seen)
  if (!date) return ''
  return formatFromNow(date)
}

export const formatVideoPostDuration = (seconds) => {
  const totalSeconds = Number.parseInt(seconds, 10)
  if (Number.isNaN(totalSeconds) || totalSeconds < 0) return '0:0'
  const minutes = Math.floor(totalSeconds / 60)
  const remainingSeconds = totalSeconds % 60
  return `${minutes}:${String(remainingSeconds).padStart(2, '0')}`
}
